import { Grid, Typography } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import BannerCoursesDurationFee from "../../muiCommonComponent/bannerCoursesDurationFee";
import { ListDataPresentation, TableDataPresentation } from "../../../utils/utils";
const BPharma=()=>{
    const progHiglight=[
{listName:'1. Why Choose B. Pharmacy at MVN University – A PCIApproved Institution'},
{listName:'Pursuing a Bachelor of Pharmacy (B. Pharmacy) from MVN University, approved by the Pharmacy Council of India (PCI), ensures a future-ready education aligned with national regulatory standards. Here’s why a PCIrecognized B. Pharmacy course at MVN is the ideal stepping stone for your pharmaceutical career:'},
{listName:'2. National Recognition and Credibility'},
{listName:'Being PCIapproved ensures that our curriculum meets the stringent standards set by the governing body of pharmacy education in India. This recognition enhances the value of your degree, making you eligible for professional licensure and government jobs across India.'},
{listName:'3. Industry-Aligned Curriculum'},
{listName:'Our course structure is regularly updated to reflect the latest advancements in pharmaceutical sciences, technology, and research. This ensures students are equipped with relevant knowledge and practical skills demanded by the healthcare and pharmaceutical industry.'},
{listName:'4. Hands-On Practical Training'},
{listName:'With state-of-the-art laboratories and industrystandard equipment, MVN provides extensive hands-on experience. Students gain confidence in pharmaceutical formulation, analysis and quality control through real-world training modules.'},
{listName:'5. Career Opportunities & Higher Education'},
{listName:'Graduates from a PCIapproved program are eligible for:'},
{listName:'Government and private sector jobs in pharmaceutical companies, hospitals and research labs.'},
{listName:'Licensure as a registered pharmacist.'},
{listName:'Competitive exams for postgraduate education (M. Pharm, MBA, M. Tech, M.Sc., Pharm D. (Post Baccalaureate,etc.) or international opportunities.'},
{listName:'6. Eligibility for Clinical Practice'},
{listName:'Only graduates from PCIapproved institutions are eligible to register as pharmacists, a legal requirement to practice in community or hospital pharmacy in India.'},
{listName:'7. Industry Connections & Internships'},
{listName:'MVN maintains strong industry linkages, ensuring students have access to internships, live projects, placements in top pharmaceutical companies and healthcare organizations.'},
{listName:'8. Global Recognition'},   
{listName:'A PCIapproved degree opens doors for further studies and professional opportunities abroad, where regulatory compliance and accreditation are key for acceptance.'},
{listName:'Join MVN’s B. Pharmacy program – where academic excellence meets professional integrity. Build a strong foundation for a rewarding career in healthcare and pharmaceuticals, guided by expert faculty and supported by cuttingedge infrastructure.'}  

    ]
    const feeStructureData=[
        {duration:'1st Year Onwards Fees','4 Years':'₹150000/- (Tuition Fee - ₹130000 + Other Charges- ₹20000/-)'},
        // {duration:'2nd Year Onwards Fees','4 Years':'₹147000/- ( Tuition Fee – ₹130000 + Other Charges- ₹ 17000/-)'}
    ]
    const hostalFeeData=[
        {item:'Triple Seater with Meal','fee':'₹ 96000/-'},
        {item:'Triple Seater (AC) with Meal','fee':'₹130000/-'}
    ]
    const duration='4 years'
    const fee_1st= '1,50,000'
    const fee_2nd= '1,50,000'
    const eligibility='Candidate shall have passed 10+2 examination conducted by the respective state/central government authorities recognized as equivalent to 10+2 examination by the Association of Indian Universities (AIU) with English as one of the subjects and Physics, Chemistry, Mathematics (P.C.M) and or Biology (P.C.B / P.C.M.B.) as optional subjects individually. Any other qualification approved by the Pharmacy Council of India as equivalent to any of the above examinations. '
return (
<Grid container spacing={2}>
<Grid item xs={12}>
<BannerCoursesDurationFee duration={duration} fee_1st={fee_1st} fee_2nd={fee_2nd} eligibility={eligibility}/>
    </Grid>
<Grid item xs={12}>
    <MainTitle title="B. Pharmacy" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="About the Program" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Pharmacy education in India plays a vital role in producing skilled professionals who contribute significantly to the healthcare system. With advancements in healthcare and evolving Pharmaceutical industries, it becomes imperative to continuously enhance the Pharmacy programme to meet the demands of the modern world. Pharmacy education encompasses various programs tailored to equip students with the necessary knowledge and skills to excel in the Pharmaceutical industry.
<br/><br/>
The B. Pharmacy program at the School of Pharmaceutical Sciences, MVN University, is designed to provide students with a comprehensive understanding of Pharmaceutical sciences and prepare them for careers in the Pharmaceutical industry, research, hospitals, and academia. Here are some key aspects of the program:
<br/><br/>
<ol>
<li><b>- Curriculum:</b> The curriculum covers a wide range of subjects including Pharmaceutics, Pharmaceutical chemistry, Pharmacology, Pharmacognosy, Pharmaceutical analysis, and Pharmaceutical technology, Jusrisprudance, drug discovery, regulatory affairs, drug development, and quality assurance.</li>
<li><b>- Practical Training:</b> The program emphasizes hands-on practical training in Industries, hospitals and laboratories to develop skills in drug formulation, analysis, and testing. </li>
<li><b>- Research Opportunities:</b> The school is offering opportunities for students to engage in research projects under the guidance of faculty members. This can provide valuable experience and enhance students' understanding of the latest developments in Pharmaceutical sciences.</li>
<li><b>- Industry Collaboration:</b> The school have collaborations with Pharmaceutical companies, research institutions, hospitals and regulatory agencies, providing students with exposure to industry practices and networking opportunities.</li>
<li><b>- Career Prospects:</b> Graduates of the B. Pharmacy program from the School of Pharmaceutical Sciences, MVN University, are well-equipped to pursue careers as pharmacists, formulation scientists, quality control/quality assurance professionals, regulatory affairs specialists, and researchers in the Pharmaceutical industry. They may also choose to pursue higher education in pharmacy or related fields.</li>
</ol>
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Eligibility" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" fontWeight={800} >
    Minimum Eligibility Criteria<br/><br/>
    </Typography>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    <b>Minimum qualification for admission In B. Pharmacy</b><br/>
<br/>
<b>First year B. Pharmacy:</b> Candidate shall have passed 10+2 examination conducted by the respective state/central government authorities recognized as equivalent to 10+2 examination by the Association of Indian Universities (AIU) with English as one of the subjects and Physics, Chemistry, Mathematics (P.C.M) and or Biology (P.C.B / P.C.M.B.) as optional subjects individually. Any other qualification approved by the Pharmacy Council of India as equivalent to any of the above examinations. 
<br/>
<b>B. Pharmacy lateral entry (to third semester):</b> A pass in D. Pharm. course from an institution approved by the Pharmacy Council of India under section 12 of the Pharmacy Act.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Programme Highlights" />
    </Grid>

    <Grid item xs={12}>
    <ListDataPresentation DataList={progHiglight}/>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Fee Structure" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    The comprehensive fee structure is designed to be transparent, helping you and your family plan effectively for all four years of the program. Below, you will find a detailed breakdown of tuition fees, including specific costs for the first year and subsequent years.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
    B. Pharmacy
    </Typography>
    <TableDataPresentation data={feeStructureData}/>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Ensure your comfort and convenience while studying at our institution with our range of hostel accommodations. We offer various options to suit your preferences, including triple seater rooms, both air-conditioned and non-air-conditioned, complete with meal plans. Below, you’ll find detailed information on our hostel fee structures for each option.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
    Hostel Fee
    </Typography>
    <TableDataPresentation data={hostalFeeData}/>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    <b>Note:</b> Hostel Caution Money of ₹10,000/- One Time Payment (Refundable) <br/><br/>
    </Typography>
    </Grid>
    </Grid>

)
}
export default BPharma;